import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ed2c0bfa&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=ed2c0bfa&lang=stylus&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2c0bfa",
  null
  
)

export default component.exports